<template>
  <div class="app-root">
    <RouterView />
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'

// Chrome / Safari 100vh bug fix
function setBodyHeight() {
  document.body.style.height = `${window.innerHeight}px`
}

onMounted(() => {
  window.addEventListener('resize', setBodyHeight)
  setBodyHeight()
})

onUnmounted(() => {
  window.removeEventListener('resize', setBodyHeight)
})
</script>

<style scoped>
.app-root {
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>
